export var LinkTypes;
(function (LinkTypes) {
    LinkTypes["NoLink"] = "NoLink";
    LinkTypes["PageLink"] = "PageLink";
    LinkTypes["AnchorLink"] = "AnchorLink";
    LinkTypes["ExternalLink"] = "ExternalLink";
    LinkTypes["DocumentLink"] = "DocumentLink";
    LinkTypes["PhoneLink"] = "PhoneLink";
    LinkTypes["EmailLink"] = "EmailLink";
    LinkTypes["LoginToWixLink"] = "LoginToWixLink";
    LinkTypes["DynamicPageLink"] = "DynamicPageLink";
    LinkTypes["EdgeAnchorLink"] = "EdgeAnchorLinks";
    LinkTypes["PopupLink"] = "PopupLink";
    LinkTypes["FormSubmitButtonLink"] = "FormSubmitButtonLink";
})(LinkTypes || (LinkTypes = {}));
export var DeviceType;
(function (DeviceType) {
    DeviceType["Desktop"] = "desktop";
    DeviceType["Mobile"] = "mobile";
})(DeviceType || (DeviceType = {}));
export var TPAComponentType;
(function (TPAComponentType) {
    TPAComponentType["Page"] = "PAGE";
    TPAComponentType["Widget"] = "WIDGET";
})(TPAComponentType || (TPAComponentType = {}));
export var WidgetInstallationType;
(function (WidgetInstallationType) {
    WidgetInstallationType["Open"] = "open";
    WidgetInstallationType["Closed"] = "closed";
})(WidgetInstallationType || (WidgetInstallationType = {}));
const AppController = 'platform.components.AppController';
const AppWidget = 'platform.components.AppWidget';
const Page = 'mobile.core.components.Page';
//# sourceMappingURL=common.js.map